import React from "react";
import ReactDom from "react-dom";

import {observable, action, computed} from 'mobx';
import {observer} from 'mobx-react';

import {Decorator as editable} from 'simbox-editable';

import autoclass from 'autoclass-decorator';

import BaseComponent from 'base-component';

import {ProgressBarViewStore} from './viewstore';
import {ProgressBarContentModel} from './contentmodel';


//@editable // this makes the view editable via authoring tool via data-editable
@observer // mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
export class ProgressBarComponent extends BaseComponent {

    static get ViewStore() {
        return ProgressBarViewStore;
    }
  
    render() {
        const {
            currentView, // the parent view container, may have options etc attached depending on context
            contentModel, // the hydrated contentModel
        } = this.props;

        const {
            label,
            css,
        } = contentModel; // this contentModel's properties

        let width = (this.viewStore.value * 100) + "%";
        return (
            <div className={"progress-bar " + css}>
                <div className="progress-bar-container">
                    <div className="progress-bar-bar" style={{width: width}}></div>
                </div>
                <span className="progress-bar-label" dangerouslySetInnerHTML={{__html: label}}></span>
            </div>
        )
    }
}

export default ProgressBarComponent; //need to export top level component as "default"



// WEBPACK FOOTER //
// ./app_modules/form-control-activity/progress/component.js